module.exports = __webpack_public_path__ + "img/20220502_104515.36940bb0.jpg";